export function sortAlphabetically<T>(array: T, property: string) {
  if (Array.isArray(array)) {
    return array.sort((a, b) => {
      const textA = a[property].toUpperCase();
      const textB = b[property].toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  } else return array;
}
